var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.045,
    height: 12.746,
    viewBox: "0 0 16.045 12.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-489.977,12.746V10.934h8.023v1.812ZM-498,7.128V5.316h16.045V7.128Zm0-5.316V0h16.045V1.812Z",
    transform: "translate(498)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon);
export default __webpack_public_path__ + "static/media/sidebarIcon.240e56a9989168fec741c7ab1a9a3a6e.svg";
export { ForwardRef as ReactComponent };